import { useMutation, useQueryClient } from '@tanstack/react-query';

import { companyCrmRoutingQuery } from '@/entities/company';
import {
  assignCompanyCrmIntegration,
  AssignCompanyCrmIntegrationRequestDto,
} from '@/shared/api/companies';

export function useAssignCompanyCrmIntegration(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AssignCompanyCrmIntegrationRequestDto) =>
      assignCompanyCrmIntegration(companyId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: companyCrmRoutingQuery(companyId).queryKey,
      });
      queryClient.invalidateQueries({ queryKey: ['integration', 'list'] });
    },
  });
}
